export const filterTopItems = (data: any) => {
  return data?.filter((item: any) => item?.is_top);
};
export const filterStudyAbroad = (data: any) => {
  return data?.filter((item: any) => item?.is_related_study_abroad);
};
export const filterNative = (data: any) => {
  return data?.filter((item: any) => !item?.is_related_study_abroad);
};

export const filterCount = (data: any) => {
  return data?.filter((item: any) => item?.colleges?.count !== 0);
};

export const filterIsAbroadCountry = (entity?: { country?: { country_name?: string } }): boolean => {
  return entity?.country?.country_name ? entity.country.country_name !== 'India' : false;
};

export function formatCost(value: number) {
  const yearlyValue = value * 12;

  if (yearlyValue >= 1000) {
    return `${(yearlyValue / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  }
  return yearlyValue.toString();
}

export const capitalizeFirstLetter = (value: string) => value?.charAt(0).toUpperCase() + value?.slice(1).toLowerCase();

export const capitalizeLocationName = (location: string) => {
  return location
    ?.split(' ')
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(' ');
};
